namespace Matrix.Data {
    export class TranslationColumns {
        static columnsKey = 'Data.Translation';
    }
}
